import { Component, OnInit } from "@angular/core";
import { HabilTrackerService } from "../../service/tracker.service";
import {
  ClassificacaoDTO,
  FiltrosDetalhesDTO,
  RetornoConsultaDetalhesDTO,
  RetornoConsultaDetalhesValoresDTO,
} from "../../dto/ConsultaRegistroDTO";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { clone } from "src/app/utilities/util/clone-utils";
import { MessageService } from "primeng/api";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

@Component({
  selector: "habil-dashboard-detalhes",
  templateUrl: "./dashboard-detalhes.component.html",
  styleUrls: ["./dashboard-detalhes.component.scss"],
})
export class DashboardDetalhesComponent implements OnInit {
  dto: FiltrosDetalhesDTO;
  classificacao: ClassificacaoDTO;

  retorno: RetornoConsultaDetalhesDTO;
  totais: RetornoConsultaDetalhesValoresDTO;

  constructor(
    public config: DynamicDialogConfig,
    public modal: DynamicDialogRef,
    public message: MessageService,
    public tracker: HabilTrackerService
  ) {}

  ngOnInit() {
    this.dto = this.config?.data?.dto;
    this.classificacao = this.config?.data?.classificacao;
    this.buscarDetalhes();
  }

  buscarDetalhes() {
    this.tracker
      .getDadosDetalhesRegistros(this.dto)
      .then((ret) => {
        if (ret) {
          this.retorno = clone(ret);
          this.totais = this.retorno.dados;
          console.log(this.retorno);
        }
      })
      .catch((error) => {
        console.log(error);
        this.message.add({
          severity: "error",
          summary: "Erro",
          detail: "Ocorreu um erro ao consultar os detalhes",
        });
        this.fechar();
      });
  }

  exportar() {
    const planilhaData = this.retorno.detalhes.map((d) => {
      const tenant = this.dto.registros.find((r) => r.tenant == d.tenant.replace("tn", ""));
      return {
        Empresa: tenant?.nome ?? "",
        UF: tenant?.uf ?? "",
        Whatsapp: tenant?.telefone ?? "",
        "Acessou últimos 3 dias":
          d.dados.login.acessaramUltimos5 > 0 ? "Sim" : "Não",
        "Não acessa há 15 dias":
          d.dados.login.naoAcessaramUltimos15 > 0 ? "Sim" : "Não",
        "Fez cadastro": d.dados.cadastro > 0 ? "Sim" : "Não",
        "Fez lançamento financeiro": d.dados.lancamento > 0 ? "Sim" : "Não",
        "Movimento comercial": d.dados.comercial > 0 ? "Sim" : "Não",
        "Prestação de serviço": d.dados.servico > 0 ? "Sim" : "Não",
      };
    });

    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(planilhaData);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Detalhes por Tenant");

    const excelBuffer: any = XLSX.write(wb, {
      bookType: "xlsx",
      type: "array",
    });
    const blob: Blob = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });
    saveAs(
      blob,
      `central_clientes_${this.classificacao.descricao}_detalhes.xlsx`
    );
  }

  fechar() {
    this.modal.close();
  }
}
